import { render, staticRenderFns } from "./RazorPayIntegration.vue?vue&type=template&id=68beedfe&scoped=true"
import script from "./RazorPayIntegration.vue?vue&type=script&lang=js"
export * from "./RazorPayIntegration.vue?vue&type=script&lang=js"
import style0 from "./RazorPayIntegration.vue?vue&type=style&index=0&id=68beedfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68beedfe",
  null
  
)

export default component.exports